var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'no-scroll':
      _vm.$route.path.includes('/your-parking/guest') ||
      _vm.$route.path.includes('/your-parking/cyberport-guest'),
  }},[_c('Confirm',{staticClass:"confirm-dialog"}),_c('Loader'),_c('NotificationPopup'),_c('Downloading'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }